<script lang="ts" setup>
import { CardItem } from '@/components/ui/types'
import { Autoplay, Mousewheel } from 'swiper/modules'

const {
  items,
  slidesPerView,
} = defineProps<{
  items: CardItem[]
  slidesPerView: number
}>()

const getCardRotation = (index: number) => {
  const rotations = [-12, 0, 5, -2, 8, -2, 4]
  return rotations[index % rotations.length]
}

const currentIndex = ref(0)

const isVisible = (index: number) => {
  const startIndex = currentIndex.value
  if (startIndex + slidesPerView <= items.length) {
    return index >= startIndex && index < startIndex + slidesPerView
  } else {
    const remaining = slidesPerView - (items.length - startIndex)
    return index >= startIndex || index < remaining
  }
}
</script>

<template>
  <div class="mx-auto w-100">
    <div class="overflow-hidden my-n20 mx-md-n12 ma-lg-n20">
      <swiper
        :slides-per-view="slidesPerView"
        :loop="true"
        class="justify-center overflow-visible py-20 px-md-12 pa-lg-20"
        v-bind="$attrs"
        :modules="[
          Autoplay,
          Mousewheel,
        ]"
        :style="{
          maxWidth: '100svw'
        }"
        :mousewheel="{
          forceToAxis: true,
        }"
        @slide-change="(swiper) => currentIndex = swiper.realIndex ?? swiper.activeIndex"
      >
        <swiper-slide
          v-for="(item, index) in items"
          :key="index"
          class="card-slide"
          :class="{
            'card-slide-visible': isVisible(index),
          }"
        >
          <slot
            name="card"
            :item="item"
            :index="index"
            :current-index="currentIndex"
          >
            <ui-card
              :src="item.src"
              :type="item.type"
              :rotate="getCardRotation(index)"
              :card="item.card"
            />
          </slot>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style lang="scss">
.card-slide {
  opacity: 0;
  transform: translateY(20px);
}

.card-slide-visible {
  animation: slideInUp 0.6s ease forwards;
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
